import type { UI__BETSLIP_EXC_PLACE_BET_CLICK_AUTO_CONFIRM } from "@ppb/tbd-store/actions/betslip";
import type { ExchangeSide, URN } from "../../../types";

type PotentialBetChangePayload = {
  runner: URN;
  side: ExchangeSide;
  price?: number;
  size?: number;
};

type UnmatchedBetChangePayload = {
  runner: URN;
  side: ExchangeSide;
  price?: number;
  size?: number;
};

export const UI__BETSLIP_EXC_PRICE_INPUT_CHANGE = "UI/BETSLIP_EXC_PRICE_INPUT_CHANGE";

export type BetslipExchangePriceInputChangeAction = {
  type: typeof UI__BETSLIP_EXC_PRICE_INPUT_CHANGE;
  payload: PotentialBetChangePayload;
};

export const UI__BETSLIP_EXC_PRICE_INPUT_BLUR = "UI/BETSLIP_EXC_PRICE_INPUT_BLUR";

export type BetslipExchangePriceInputBlurAction = {
  type: typeof UI__BETSLIP_EXC_PRICE_INPUT_BLUR;
  payload: PotentialBetChangePayload;
};

export const UI__BETSLIP_EXC_SIZE_INPUT_CHANGE = "UI/BETSLIP_EXC_SIZE_INPUT_CHANGE";

export type BetslipExchangeSizeInputChangeAction = {
  type: typeof UI__BETSLIP_EXC_SIZE_INPUT_CHANGE;
  payload: PotentialBetChangePayload;
};

export const UI__BETSLIP_EXC_UNMATCHED_PRICE_INPUT_CHANGE = "UI/BETSLIP_EXC_UNMATCHED_PRICE_INPUT_CHANGE";

export type BetslipExchangeUnmatchedPriceInputChangeAction = {
  type: typeof UI__BETSLIP_EXC_UNMATCHED_PRICE_INPUT_CHANGE;
  payload: UnmatchedBetChangePayload;
};

export const UI__BETSLIP_EXC_UNMATCHED_PRICE_INPUT_BLUR = "UI/BETSLIP_EXC_UNMATCHED_PRICE_INPUT_BLUR";

export type BetslipExchangeUnmatchedPriceInputBlurAction = {
  type: typeof UI__BETSLIP_EXC_UNMATCHED_PRICE_INPUT_BLUR;
  payload: UnmatchedBetChangePayload;
};

export const UI__BETSLIP_EXC_UNMATCHED_SIZE_INPUT_CHANGE = "UI/BETSLIP_EXC_UNMATCHED_SIZE_INPUT_CHANGE";

export type BetslipExchangeUnmatchedSizeInputChangeAction = {
  type: typeof UI__BETSLIP_EXC_UNMATCHED_SIZE_INPUT_CHANGE;
  payload: UnmatchedBetChangePayload;
};

export const UI__BETSLIP_EXC_CONFIRM_PANEL_BACK_CLICK = "UI/BETSLIP_EXC_CONFIRM_PANEL_BACK_CLICK";

export type BetslipExchangeConfirmPanelBackClickAction = {
  type: typeof UI__BETSLIP_EXC_CONFIRM_PANEL_BACK_CLICK;
};

export const UI__BETSLIP_BET_WITH_MATCH_ME_CLICK = "UI/BETSLIP_BET_WITH_MATCH_ME_CLICK";

export type BetslipBetWithMatchMeClickAction = {
  type: typeof UI__BETSLIP_BET_WITH_MATCH_ME_CLICK;
  payload: {
    marketURN: URN;
    runner: URN;
    side: ExchangeSide;
    marketDepth: number;
    price?: number;
    size?: number;
  };
};

export const BETSLIP__EXC_BET_REQUESTED = "BETSLIP/EXC_BET_REQUESTED";

export type BetslipExchangeBetRequestedAction = {
  type: typeof BETSLIP__EXC_BET_REQUESTED;
  payload: {
    runner: URN;
    side: ExchangeSide;
    market: URN;
    marketDepth: number;
    marketId?: string;
    isSp: boolean;
  };
};

export const BETSLIP__EXC_EDIT_REQUESTED = "BETSLIP/EXC_EDIT_REQUESTED";

export type BetslipExchangeEditRequestedAction = {
  type: typeof BETSLIP__EXC_EDIT_REQUESTED;
  payload: {
    betId: string;
    runner: URN;
    side: ExchangeSide;
    market: URN;
  };
};

export const BETSLIP__EXC_DISMISS = "BETSLIP/EXC_DISMISS";

export type BetslipExchangeDismissAction = {
  type: typeof BETSLIP__EXC_DISMISS;
};

export const NETWORK__PLACE_EXC_BET_IN_PROGRESS = "NETWORK/PLACE_EXC_BET_IN_PROGRESS";

export type PlaceExchangeBetInProgressAction = {
  type: typeof NETWORK__PLACE_EXC_BET_IN_PROGRESS;
};

export const NETWORK__UPDATE_EXC_BET_IN_PROGRESS = "NETWORK/UPDATE_EXC_BET_IN_PROGRESS";

export type UpdateExchangeBetInProgressAction = {
  type: typeof NETWORK__UPDATE_EXC_BET_IN_PROGRESS;
};

export const NETWORK__CANCEL_EXC_BET_IN_PROGRESS = "NETWORK/CANCEL_EXC_BET_IN_PROGRESS";

export type CancelExchangeBetInProgressAction = {
  type: typeof NETWORK__CANCEL_EXC_BET_IN_PROGRESS;
};

export type BetslipExchangePlaceBetClickAutoConfirm = {
  type: typeof UI__BETSLIP_EXC_PLACE_BET_CLICK_AUTO_CONFIRM;
  payload: { runner: URN };
};
